"use strict";

exports.__esModule = true;
exports.DescriptionElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _common = require("../common");
var _Device = require("../../Device");
var _Core = require("../../Core");
var _dec, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a label for a section.
 */
var DescriptionElement = exports.DescriptionElement = (_dec = _Device.DeviceContext.withContext, _dec(_class = /*#__PURE__*/function (_Component) {
  function DescriptionElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DescriptionElement, _Component);
  var _proto = DescriptionElement.prototype;
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      content = _this$props.content,
      device = _this$props.device,
      color = _this$props.color,
      backgroundColor = _this$props.backgroundColor,
      backgroundColorSource = _this$props.backgroundColorSource;
    if (backgroundColorSource && device) {
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
        deviceUuid: device.uuid
      }, (0, _common.getWidgetColorProps)(this.props)), function (_ref) {
        var color = _ref.color,
          backgroundColor = _ref.backgroundColor;
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          style: Object.assign({
            overflowY: "auto",
            color: color,
            backgroundColor: backgroundColor
          }, (0, _common.getWidgetPositionProps)(_this.props), (0, _common.getWidgetFontProps)(_this.props, "css"))
        }, (0, _common.getWidgetInteractionProps)(_this.props)), /*#__PURE__*/_react["default"].createElement(_Core.PlainText, {
          content: content
        }));
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      style: Object.assign({
        overflowY: "auto",
        color: color,
        backgroundColor: backgroundColor
      }, (0, _common.getWidgetPositionProps)(this.props), (0, _common.getWidgetFontProps)(this.props, "css"))
    }, (0, _common.getWidgetInteractionProps)(this.props)), /*#__PURE__*/_react["default"].createElement(_Core.PlainText, {
      content: content
    }));
  };
  return DescriptionElement;
}(_react.Component)) || _class);